import { Search } from '@mui/icons-material';
import { Box, InputAdornment, TextField } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';

interface SearchBarForwardProps {
  onSearchChange: (query: string) => void;
  placeholder?: string;
}

export const SearchBarForward: React.FC<SearchBarForwardProps> = ({ onSearchChange, placeholder = 'Tìm kiếm' }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');

  // Debounce search with 300ms delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  // Call onSearchChange when debounced query changes
  useEffect(() => {
    onSearchChange(debouncedQuery);
  }, [debouncedQuery, onSearchChange]);

  const handleSearchChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchQuery(value);
  }, []);

  return (
    <Box className='mex:px-4 mex:py-3'>
      <TextField
        fullWidth
        variant='outlined'
        placeholder={placeholder}
        value={searchQuery}
        onChange={handleSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Search className='mex:text-gray-400' />
            </InputAdornment>
          )
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: 'action.hover',
            '& fieldset': {
              border: 'none'
            },
            '&:hover fieldset': {
              border: 'none'
            },
            '&.Mui-focused fieldset': {
              border: '1px solid',
              borderColor: 'primary.main'
            }
          },
          '& .MuiInputBase-input': {
            padding: '12px 16px',
            fontSize: '16px',
            '&::placeholder': {
              color: 'text.disabled',
              opacity: 1
            }
          }
        }}
      />
    </Box>
  );
};
